const hotel = {
  availableMealPlans: "이용 가능한 식사 플랜", // translated 
  availableRoomsTypes: "이용 가능한 객실 유형", // translated 
  cancellationPolicy: "취소 정책", // translated 
  cancellationRules: "취소 규정", // translated 
  freeCancellationAvailable: "무료 취소 가능", // translated 
  nonRefundable: "환불 불가", // translated 
  priceFor: "가격", // translated 
  nights: "밤", // translated 
  totalPrice: "총 가격", // translated 
  seeAvailability: "이용 가능 여부 확인", // translated 
  myProfile: "내 프로필", // translated 
  travelTrust: "여행 신탁", // translated 
  signIn: "로그인", // translated 
  searchNow: "지금 검색하세요", // translated 
  policy: "정책", // translated 
  cxlRules: "CXL 규칙", // translated 
  room: "방", // translated 
  cxlPolicy: "CXL 정책", // translated 
  beddingType: "침구 종류", // translated 
  hotelName: "호텔 이름", // translated 
  reservationDate: "예약 날짜", // translated 
  maxPax: "최대 인원", // translated 
};


export default hotel;
